export default "/images/cake.svg?14c0bac29f16534cff78aa1cab0360f4";